/**
 * Copyright (c) 2024, Ouster, Inc.
 * All rights reserved.
 */
import { action, Action as EzPzAction } from 'easy-peasy';

export type State = {
  isOpen: boolean;
  isPublicWarningOpen: boolean;
};

export const defaultState: State = {
  isOpen: false,
  isPublicWarningOpen: false,
};

export interface RecordingUploadModel extends State {
  setIsOpen: EzPzAction<RecordingUploadModel, boolean>;
  setIsPublicWarningOpen: EzPzAction<RecordingUploadModel, boolean>;
}

export const modal: RecordingUploadModel = {
  ...defaultState,
  setIsOpen: action((state, isOpen) => {
    state.isOpen = isOpen;
  }),
  setIsPublicWarningOpen: action((state, isOpen) => {
    state.isPublicWarningOpen = isOpen;
  }),
};
